export default __webpack_public_path__ + "static/media/Chocolate-Cake.ea8c8ec9.jpg";